import { useCallback, useRef, useState } from 'react';
import { useToast } from '@chakra-ui/react';
import { attendanceApi } from 'api';

export function useAttendanceNfcScan() {
  const toast = useToast();
  const [scanning, setScanning] = useState(false);
  const [lastScan, setLastScan] = useState(null);
  const scanningRef = useRef(false);

  const handleScan = useCallback(
    async (uid) => {
      if (scanningRef.current) return;
      scanningRef.current = true;
      setScanning(true);
      try {
        const res = await attendanceApi.scanNfc(uid);
        setLastScan({
          ok: true,
          message: res.message,
          action: res.action,
          isLate: res.isLate,
        });
        const status =
          res.action === 'check_out'
            ? 'info'
            : res.isLate
              ? 'warning'
              : res.action === 'already_done'
                ? 'info'
                : 'success';
        toast({ title: res.message, status, duration: 5000, isClosable: true });
        window.dispatchEvent(new CustomEvent('attendance:nfc-scanned', { detail: res }));
        return res;
      } catch (e) {
        const msg = e.response?.data?.message || e.message || 'Ошибка отметки';
        setLastScan({ ok: false, message: msg, uid: e.response?.data?.uid });
        toast({ title: msg, status: 'warning', duration: 5000, isClosable: true });
        throw e;
      } finally {
        scanningRef.current = false;
        setScanning(false);
      }
    },
    [toast]
  );

  return { scanning, lastScan, handleScan, setLastScan };
}
